"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AddListTableRow = exports.AddListTableItem = exports.AddListTableHeader = exports.AddListTableBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AddListTable = require("./AddListTable.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 可增加列表的Table
 */

const AddListTable = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTable, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalContentList"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalTable"
  }, children)));
};
var _default = exports.default = AddListTable;
AddListTable.propTypes = {
  children: _propTypes.default.any
};
const AddListTableRow = _ref2 => {
  let {
    children,
    isadmin
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableRow, {
    isadmin: isadmin
  }, children);
};
exports.AddListTableRow = AddListTableRow;
AddListTableRow.propTypes = {
  children: _propTypes.default.any,
  isadmin: _propTypes.default.bool
};
const AddListTableHeader = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableHeader, null, children);
};
exports.AddListTableHeader = AddListTableHeader;
AddListTableHeader.propTypes = {
  children: _propTypes.default.any
};
const AddListTableBody = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableBody, null, children);
};
exports.AddListTableBody = AddListTableBody;
AddListTableBody.propTypes = {
  children: _propTypes.default.any
};
const AddListTableItem = _ref5 => {
  let {
    children,
    flex
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableItem, {
    flex: flex
  }, children);
};
exports.AddListTableItem = AddListTableItem;
AddListTableItem.propTypes = {
  children: _propTypes.default.any,
  flex: _propTypes.default.number
};